import React from "react";
import {
  Stepper,
  Step,
  StepButton,
  Box,
} from "@material-ui/core";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import AfterGateWayForms from "./AfterGatewayForms";
import AfterGatewayTicketDetails from "./AfterGatewayTicketDetails";
import { actions } from "../../SearchPage/_redux/searchRedux";
import {
  getTicketDetails,
  getAllFavPassengers,
} from "../pages/widgets/components/cruds";
import { useDispatch, useSelector } from "react-redux";

const muiTheme = createMuiTheme({
  overrides: {
    MuiStepConnector: {
      root: {
        height: "3.3px",
        borderRadius: "5px",
        "&$active": {
          background: "#6dd06d",
        },
      },
    },
    MuiStepIcon: {
      root: {
        color: "darkgray", // or 'rgba(0, 0, 0, 1)'
        "&$active": {
          color: "#6dd06d",
        },
        "&$completed": {
          color: "#6dd06d",
        },
        fontSize: "35px",
        display: "block",
      },
      text: {
        fontFamily: "sans",
      },
    },
    MuiStepLabel: {
      root: {
        display: "block",
        color: "red", // or 'rgba(0, 0, 0, 1)'
        "&$active": {
          color: "green",
        },
        "&$completed": {
          color: "#6dd06d",
        },
      },
      iconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "5px",
      },
      label: {
        "&$active": {
          color: "#6dd06d",
          fontWeight: "bolder",
        },
        "&$completed": {
          color: "#6dd06d",
        },
      },
    },
  },
});

const steps = [
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>انتخاب</span> <span className="d-none d-md-inline">اتوبوس</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>مشخصات</span> <span className="d-none d-md-inline">مسافر</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>تایید</span> <span className="d-none d-md-inline">اطلاعات</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>پرداخت</span>
  </h4>,
  <h4 style={{ fontFamily: "sans", fontSize: "14px" }}>
    <span>صدور</span> <span className="d-none d-md-inline">بلیط</span>
  </h4>,
];

const AfterGateway = (props) => {
  const [activeStep, setActiveStep] = React.useState(3);
  const [completed, setCompleted] = React.useState({
    0: true,
    1: true,
    2: true,
  });
  const [apiStats, setApiStats] = React.useState(0);
  
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));
  

  const history = useHistory();
  const dispatch = useDispatch();
  const splittedURL = history.location.pathname.split("/");

  const pageUseEffect = () => {
    dispatch(
      actions.setUser(
        JSON.parse(window.localStorage.getItem("userInformation"))
      )
    );

    const params = {
      ticketId: +splittedURL[2],
    };
    getTicketDetails(params, authState.user.token)
      .then((res) => {
        setApiStats(1);
        dispatch(actions.setTicketStats(res.data.data));
        dispatch(actions.setFullSeats(res.data.data?.TravelTicketDetails));
      })
      .catch(() => {
        setApiStats(-1);
      });
    getAllFavPassengers(authState.user.token).then((res) => {
      res.data.data.push({
        passengerFirstName: authState.user.user.firstName,
        passengerLastName: authState.user.user.lastName,
        passengerNationalCode: authState.user.user.nationalCode,
      });

      dispatch(actions.setFavPassengers(res.data.data));
    });
  };

  React.useEffect(() => {
    pageUseEffect();
  }, []);

  const componentSituationSetter = (step) => {
    switch (+step) {
      // case 3:
        // return (
        //   <AfterGateWayForms
        //     handleComplete={handleComplete}
        //     apiStats= {apiStats}
        //   />
        //   // این بخش برای تکمیل اطلاعات در صورت برگشت تایید از سمت بانک است
        // );
      case 3:
        return <AfterGatewayTicketDetails handleComplete={handleComplete} />;
        // این بخش برای بعد از پرداخت است که اطلاعات بلیط را نشان می دهد.

      default:
        // return <AfterGateWayForms handleComplete={handleComplete} />;
        return <AfterGatewayTicketDetails handleComplete={handleComplete} />
    }
  };

  return (
    <>
      <div className="bg-white" style={{ borderTop: "1px solid darkgray" }}>
        <Box style={{ overflow: "auto" }} className="container">
          <MuiThemeProvider theme={muiTheme}>
            <Stepper
              nonLinear
              style={{ overflow: "auto" }}
              activeStep={activeStep}
            >
              {steps.map((label, index) => (
                <Step key={label} completed={completed[index]}>
                  <StepButton
                    color="white"
                    style={{ color: "white", display: "block" }}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          </MuiThemeProvider>
        </Box>
      </div>
      {componentSituationSetter(activeStep)}
    </>
  );
};

export default AfterGateway;
